import { CSSObject } from '@chakra-ui/react';

export const TransactionsContainer: CSSObject = {
  'div[data-cy="activityStatements"]': {
    'p:nth-of-type(1)': {
      mb: '14px',
    },
  },
};
